import React from "react";
import { Spin } from "antd";

const ComponentLoader = ({ minHeight = "300px" }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight,
      width: "100%",
    }}
  >
    <Spin size="large" />
  </div>
);

export default ComponentLoader;
